import Splide from "@splidejs/splide";

export default function initCarousel(id, config = {}) {
  const defaultConfig = {
    type: "loop",
    perPage: 1,
    focus: "center",
    padding: 40,
    gap: 24,
    pagination: false,

    mediaQuery: "min",
    breakpoints: {
      800: {
        gap: 64,
        padding: 116,
        perPage: 1,
      },
      1200: {
        padding: 116,
        perPage: 2,
      },
      1800: {
        padding: 116,
        perPage: 3,
      },
    },
    autoplay: true,
    interval: 3000,
    flickMaxPages: 1,
  };

  new Splide(`#${id}`, { ...defaultConfig, ...config }).mount();
}
